// @ts-nocheck

import { type StateType } from '../../../states';
import Pool from '../states/pool';
import type { GridMatchLength } from '../types';

export const getActivePoolsIds = (state: StateType): Array<number> | null | undefined => state.grids.ui.activePools;

export const getRunningGridsIds = (state: StateType): Array<string> | null | undefined => state.grids.ui.runningGrids;

export const getPoolNavigation = (state: StateType): GridMatchLength => state.grids.ui.poolNavigation;

export const getTypeActivePoolsIds = (state: StateType, type: GridMatchLength): Array<number> | undefined => {
  const activePoolsIds = getActivePoolsIds(state);
  return activePoolsIds?.filter((poolId) => Pool.getType(poolId) === type);
};

export const getNavigationActivePoolsIds = (state: StateType): Array<number> | undefined => {
  const poolNavigation = getPoolNavigation(state);
  return getTypeActivePoolsIds(state, poolNavigation);
};

const getSortedTypeActivePoolsIds = (state: StateType, type: GridMatchLength): Array<number> => {
  const poolIds = getTypeActivePoolsIds(state, type);
  return poolIds ? poolIds.sort() : [];
};

export const getLastActivePoolIdFromType = (state: StateType, type: GridMatchLength): number => {
  const poolIds = getSortedTypeActivePoolsIds(state, type);
  return poolIds.reverse()[0];
};

export const getFirstActivePoolIdFromType = (state: StateType, type: GridMatchLength): number => {
  const poolIds = getSortedTypeActivePoolsIds(state, type);
  return poolIds[0];
};
